// Central contact config — update these when the final details are ready.
// Leave COMPANY_PHONE as an empty string ("") to hide the phone number.
export const CONTACT = {
  email: "info@impresacozyhome.eu",
  phone: "", // e.g. "+31 6 12 34 56 78" — leave empty to hide
  city: "Utrecht, Netherlands",
};
